import React, { createContext, useReducer } from "react";
import PropTypes from "prop-types";

const initialState = {
  currentPage: "fields",
  selectedFields: [],
  selectedYears: ["2023"],
  selectedMonth: "September",
  selectedDates: [{ year: "2023", date: null, imagery: null }],
};

const StackAnalysisActions = {
  SET_PAGE: "SET_PAGE",
  SET_SELECTED_FIELDS: "SET_SELECTED_FIELDS",
  SET_SELECTED_YEARS: "SET_SELECTED_YEARS",
  SET_SELECTED_MONTH: "SET_SELECTED_MONTH",
  SET_SELECTED_DATES: "SET_SELECTED_DATES",
};

const reducer = (state, action) => {
  switch (action.type) {
    case StackAnalysisActions.SET_PAGE:
      return { ...state, currentPage: action.value };
    case StackAnalysisActions.SET_SELECTED_FIELDS:
      return { ...state, selectedFields: action.value };
    case StackAnalysisActions.SET_SELECTED_YEARS:
      return { ...state, selectedYears: action.value };
    case StackAnalysisActions.SET_SELECTED_MONTH:
      return { ...state, selectedMonth: action.value };
    case StackAnalysisActions.SET_SELECTED_DATES:
      return { ...state, selectedDates: action.value };
    default:
      return state;
  }
};

const StackAnalysisContext = createContext();

const StackAnalysisProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };

  return (
    <StackAnalysisContext.Provider value={value}>
      {children}
    </StackAnalysisContext.Provider>
  );
};

StackAnalysisProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { StackAnalysisContext, StackAnalysisProvider, StackAnalysisActions };
